import clsx from 'clsx'
import React, {FC, useMemo} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu, ThemeModeSwitcher} from '../../../partials'
import {fileSrc} from '../../../../_component/fileUtils'
// import {useLayout} from '../../core'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

const Topbar: FC = () => {
  // const {config} = useLayout()
  const {currentUser} = useAuth()
  const account = useMemo(() => {
    return currentUser?.accounts?.find((a) => a.id === currentUser.account_id)
  }, [currentUser])

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* begin::Theme mode */}
      <div className={clsx('d-flex align-items-center d-print-none', toolbarButtonMarginClass)}>
        <ThemeModeSwitcher
          toggleBtnClass={clsx('btn-active-light-primary btn-custom', toolbarButtonHeightClass)}
        />
      </div>
      {/* end::Theme mode */}

      {/* begin::User */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
        data-kt-menu-trigger='click'
        data-kt-menu-attach='parent'
        data-kt-menu-placement='bottom-end'
        data-kt-menu-flip='bottom'
      >
        {/* begin::Toggle */}
        <button className={clsx('btn symbol', toolbarUserAvatarHeightClass)}>
          <img
            className='me-2'
            src={
              currentUser?.image
                ? fileSrc(currentUser.image)
                : toAbsoluteUrl('/media/avatars/blank.png')
            }
            alt={currentUser?.first_name}
          />
        </button>
        <div className='d-flex flex-column overflow-hidden'>
          <div className='fw-bolder d-flex align-items-center fs-5'>{currentUser?.name}</div>
          <span className='fw-bold text-muted text-hover-primary fs-7'>{account?.role?.name}</span>
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}

      {/* begin::Aside Toggler */}
      {/* {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
          </div>
        </div>
      )} */}
    </div>
  )
}

export {Topbar}
